"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _Auth = require("../providers/Auth");

var _Config = require("../providers/Config");

var _excluded = ["children", "redirectTo"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function UnauthorizedRoute(_ref) {
  var children = _ref.children,
      _ref$redirectTo = _ref.redirectTo,
      redirectTo = _ref$redirectTo === void 0 ? "/" : _ref$redirectTo,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useConfig = (0, _Config.useConfig)(),
      appConfig = _useConfig.appConfig;

  var location = (0, _reactRouterDom.useLocation)();

  var _ref2 = appConfig || {},
      authConfig = _ref2.auth;

  var _ref3 = authConfig || {},
      _ref3$redirectTo = _ref3.redirectTo,
      _redirectTo = _ref3$redirectTo === void 0 ? redirectTo : _ref3$redirectTo;

  var _useAuth = (0, _Auth.useAuth)(),
      auth = _useAuth.auth;

  var from = new URLSearchParams(location.search).get("from") || _redirectTo;

  if (!auth.isAuthenticated) {
    return children;
  } else {
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Navigate, {
      to: from,
      replace: true
    });
  }
}

var _default = UnauthorizedRoute;
exports["default"] = _default;
module.exports = exports.default;